import { useLayoutEffect } from 'react';
import { browserDeliveryClock } from '../clients/browserClock.client.js';
import { visibleProjectionText } from '../clients/projectionDom.client.js';

/** Called by the score component with the exact object and text used in that commit. */
export function useProjectionPaint(observer, row, text, elementRef) {
  useLayoutEffect(() => {
    const token = observer?.token(row, text);
    if (!token) return undefined;
    const node = elementRef.current;
    let cancelled = false, frame = null;
    const current = () => {
      if (cancelled || elementRef.current !== node || !observer.current(token, row, text)) return false;
      const visible = visibleProjectionText(node, text);
      if (!visible) observer.notVisible(token);
      return visible;
    };
    if (!current()) return undefined;
    frame = browserDeliveryClock.frame(() => {
      if (!current()) return;
      frame = browserDeliveryClock.frame(() => {
        if (current()) observer.painted(token, row, text);
      });
    });
    return () => { cancelled = true; if (frame !== null) browserDeliveryClock.cancelFrame(frame); };
  }, [observer, row, text, elementRef]);
}
